var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout',{staticClass:"erp-list",attrs:{"menu":_vm.menu,"menu-style":"compact","menu-active":"bens"}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }